const questionsTitle = `Konfliktuskezelési Stílusok - önismereti teszt`;
const questionsDescription = `Karikázd be az A vagy a B állítások közül azt, amelyik jobban jellemzi viselkedésedet!
Lehet, hogy sem az A, sem a B állítás nem jellemző rád. Ekkor is karikázd be azt, amelyiknek az előfordulása valószínűbb!
Az eredmény megmutatja, hogy a teszt szerint melyik stílus milyen mértékben jellemző rád.`;

const resultColumns = {
  dominant: 'Domináns',
  problemSolver: 'Problémamegoldó',
  comporomise: 'Kompromiszszumra törekvő',
  bypass: 'Elkerülő',
  adaptable: 'Alkalmazkodó',
};

const questions = [
  {
    id: 0,
    answers: [
      {
        id: '0-1',
        label: 'Vannak helyzetek, mikor hagyom, hogy másoké legyen a problémamegoldás felelőssége.',
        result: 'bypass',
      },
      {
        id: '0-2',
        label:
          'Ahelyett, hogy olyasmiről tárgyaljunk, amiben nem értünk egyet, inkább azokat a dolgokat igyekszem\n' +
          'hangsúlyozni, melyekben mindketten egyetértünk.',
        result: 'adaptable',
      },
    ],
  },
  {
    id: 1,
    answers: [
      {
        id: '1-1',
        label: 'Kompromisszumos megoldást próbálok találni.',
        result: 'problemSolver',
      },
      {
        id: '1-2',
        label: 'Igyekszem mindazzal foglalkozni, ami neki és nekem fontos.',
        result: 'comporomise',
      },
    ],
  },
  {
    id: 2,
    answers: [
      {
        id: '2-1',
        label: 'Általában határozott vagyok céljaim követésében.',
        result: 'dominant',
      },
      {
        id: '2-2',
        label: 'Igyekszem a másik érzéseit kímélni és megóvni a kapcsolatot.',
        result: 'adaptable',
      },
    ],
  },
  {
    id: 3,
    answers: [
      {
        id: '3-1',
        label: 'Kompromisszumos megoldást próbálok találni.',
        result: 'comporomise',
      },
      {
        id: '3-2',
        label: 'Néha lemondok saját kívánságaimról, engedve a másik kívánságainak.',
        result: 'adaptable',
      },
    ],
  },
  {
    id: 4,
    answers: [
      {
        id: '4-1',
        label: 'Állandóan keresem a másik segítségét a megoldás kialakításában.',
        result: 'problemSolver',
      },
      {
        id: '4-2',
        label: 'Igyekszem megtenni, ami a haszontalan feszültségek elkerülése érdekében szükséges.',
        result: 'bypass',
      },
    ],
  },
  {
    id: 5,
    answers: [
      {
        id: '5-1',
        label: 'Igyekszem elkerülni, hogy kellemetlenséget csináljak magamnak.',
        result: 'dominant',
      },
      {
        id: '5-2',
        label: 'Igyekszem nyerő helyzetbe kerülni.',
        result: 'bypass',
      },
    ],
  },
  {
    id: 6,
    answers: [
      {
        id: '6-1',
        label: 'Megpróbálom későbbre halasztani az ügyet, hogy legyen egy kis időm átgondolni.',
        result: 'comporomise',
      },
      {
        id: '6-2',
        label: 'Kölcsönösségi alapon engedek bizonyos pontoknál.',
        result: 'bypass',
      },
    ],
  },
  {
    id: 7,
    answers: [
      {
        id: '7-1',
        label: 'Általában határozott vagyok céljaim követésében.',
        result: 'dominant',
      },
      {
        id: '7-2',
        label:
          'Azon vagyok, hogy a dolog minden vonatkozása és minden vitás kérdés nyíltan kifejtésre kerüljön.',
        result: 'problemSolver',
      },
    ],
  },
  {
    id: 8,
    answers: [
      {
        id: '8-1',
        label: 'Úgy érzem, nem mindig érdemes a nézeteltérések miatt gyötrődni.',
        result: 'dominant',
      },
      {
        id: '8-2',
        label: 'Nem sajnálom az erőfeszítést, hogy a magam útján járhassak.',
        result: 'bypass',
      },
    ],
  },
  {
    id: 9,
    answers: [
      {
        id: '9-1',
        label: 'Határozott vagyok céljaim követésében.',
        result: 'dominant',
      },
      {
        id: '9-2',
        label: 'Kompromisszumos megoldást próbálok találni.',
        result: 'comporomise',
      },
    ],
  },
  {
    id: 10,
    answers: [
      {
        id: '10-1',
        label:
          'Azon vagyok, hogy a dolog minden vonatkozása és minden vitás kérdés nyíltan kifejtésre kerüljön.',
        result: 'problemSolver',
      },
      {
        id: '10-2',
        label: 'Igyekszem a másik érzéseit kímélni és megóvni a kapcsolatot.',
        result: 'adaptable',
      },
    ],
  },
  {
    id: 11,
    answers: [
      {
        id: '11-1',
        label: 'Néha elkerülöm az állásfoglalást olyan esetben, amikor az vitát eredményezne.',
        result: 'comporomise',
      },
      {
        id: '11-2',
        label:
          'Nem bánom, ha megtart valamit az állításaiból, ha ő is hagyja, hogy megtartsak valamit a magaméból.',
        result: 'bypass',
      },
    ],
  },
  {
    id: 12,
    answers: [
      {
        id: '12-1',
        label: 'Közös alapot javasolok.',
        result: 'dominant',
      },
      {
        id: '12-2',
        label: 'Azon vagyok, hogy elfogadtassam az érveimet.',
        result: 'comporomise',
      },
    ],
  },
  {
    id: 13,
    answers: [
      {
        id: '13-1',
        label: 'Elmondom a gondolataimat, és érdeklődéssel hallgatom az övéit.',
        result: 'dominant',
      },
      {
        id: '13-2',
        label: 'Igyekszem megvilágítani számára álláspontom logikáját és előnyeit.',
        result: 'problemSolver',
      },
    ],
  },
  {
    id: 14,
    answers: [
      {
        id: '14-1',
        label: 'Igyekszem a másik érzéseit kímélni és megóvni a kapcsolatot.',
        result: 'bypass',
      },
      {
        id: '14-2',
        label: 'Igyekszem megtenni, ami a feszültségek elkerülése érdekében szükséges.',
        result: 'adaptable',
      },
    ],
  },
  {
    id: 15,
    answers: [
      {
        id: '15-1',
        label: 'Igyekszem nem megsérteni a másik érzéseit.',
        result: 'dominant',
      },
      {
        id: '15-2',
        label: 'Igyekszem meggyőzni a másikat arról, hogy álláspontom helytálló.',
        result: 'adaptable',
      },
    ],
  },
  {
    id: 16,
    answers: [
      {
        id: '16-1',
        label: 'Általában határozott vagyok céljaim követésében.',
        result: 'dominant',
      },
      {
        id: '16-2',
        label: 'Igyekszem megtenni, ami a haszontalan feszültségek elkerülése érdekében szükséges.',
        result: 'bypass',
      },
    ],
  },
  {
    id: 17,
    answers: [
      {
        id: '17-1',
        label: 'Ha ez a másikat boldoggá teszi, nincs ellenemre, hogy ráhagyjam elképzeléseit.',
        result: 'comporomise',
      },
      {
        id: '17-2',
        label:
          'Nem bánom, ha megtart valamit az állításaiból, ha ő is hagyja, hogy megtartsak valamit a magaméiból.',
        result: 'adaptable',
      },
    ],
  },
  {
    id: 18,
    answers: [
      {
        id: '18-1',
        label:
          'Azon vagyok, hogy a dolog minden vonatkozása és minden vitás kérdés nyíltan kifejtésre kerüljön.',
        result: 'problemSolver',
      },
      {
        id: '18-2',
        label: 'Megpróbálom későbbre halasztani az ügyet, hogy legyen egy kis időm átgondolni.',
        result: 'bypass',
      },
    ],
  },
  {
    id: 19,
    answers: [
      {
        id: '19-1',
        label: 'A nézeteltérések haladéktalan megbeszélésére törekszem.',
        result: 'problemSolver',
      },
      {
        id: '19-2',
        label:
          'Próbálom megtalálni a nyereség és veszteség mindkettőnkre nézve méltányos kombinációját.',
        result: 'comporomise',
      },
    ],
  },
  {
    id: 20,
    answers: [
      {
        id: '20-1',
        label: 'Úgy tárgyalok, hogy igyekszem tekintetbe venni a másik kívánságait.',
        result: 'problemSolver',
      },
      {
        id: '20-2',
        label: 'Mindig kész vagyok a probléma közvetlen megvitatására.',
        result: 'adaptable',
      },
    ],
  },
  {
    id: 21,
    answers: [
      {
        id: '21-1',
        label: 'Megpróbálok átmeneti álláspontot találni az övé és az enyém között.',
        result: 'dominant',
      },
      {
        id: '21-2',
        label: 'Érvényesítem kívánságaimat.',
        result: 'comporomise',
      },
    ],
  },
  {
    id: 22,
    answers: [
      {
        id: '22-1',
        label:
          'Gyakran igyekszem gondoskodni arról, hogy a megoldás mindnyájunkat elégedettséggel töltsön el.',
        result: 'problemSolver',
      },
      {
        id: '22-2',
        label: 'Vannak helyzetek, mikor hagyom, hogy másoké legyen a problémamegoldás felelőssége.',
        result: 'bypass',
      },
    ],
  },
  {
    id: 23,
    answers: [
      {
        id: '23-1',
        label:
          'Ha úgy tűnik a másikról, hogy álláspontja nagyon fontos a számára, megpróbálok igazodni a\n' +
          'szándékaihoz.',
        result: 'comporomise',
      },
      {
        id: '23-2',
        label: 'Igyekszem rávenni, hogy érje be egy kompromisszummal.',
        result: 'adaptable',
      },
    ],
  },
  {
    id: 24,
    answers: [
      {
        id: '24-1',
        label: 'Igyekszem megvilágítani számára álláspontom logikáját és előnyeit.',
        result: 'dominant',
      },
      {
        id: '24-2',
        label: 'Úgy tárgyalok, hogy igyekszem tekintetbe venni a másik kívánságait.',
        result: 'adaptable',
      },
    ],
  },
  {
    id: 25,
    answers: [
      {
        id: '25-1',
        label: 'Közös alapot javasolok.',
        result: 'problemSolver',
      },
      {
        id: '25-2',
        label: 'Szinte mindig törődöm vele, hogy a megoldás mindkettőnk számára kielégítő legyen.',
        result: 'comporomise',
      },
    ],
  },
  {
    id: 26,
    answers: [
      {
        id: '26-1',
        label: 'Néha elkerülöm az állásfoglalást olyan esetben, amikor az vitát eredményezne.',
        result: 'bypass',
      },
      {
        id: '26-2',
        label: 'Ha ez a másikat boldoggá teszi, nincs ellenemre, hogy ráhagyjam elképzeléseit.',
        result: 'adaptable',
      },
    ],
  },
  {
    id: 27,
    answers: [
      {
        id: '27-1',
        label: 'Általában határozott vagyok céljaim követésében.',
        result: 'dominant',
      },
      {
        id: '27-2',
        label: 'Általában keresem a másik segítségét a megoldás kialakításában.',
        result: 'problemSolver',
      },
    ],
  },
  {
    id: 28,
    answers: [
      {
        id: '28-1',
        label: 'Közös alapot javasolok.',
        result: 'comporomise',
      },
      {
        id: '28-2',
        label: 'Úgy érzem, nem mindig érdemes a nézeteltérések miatt gyötrődni.',
        result: 'bypass',
      },
    ],
  },
  {
    id: 29,
    answers: [
      {
        id: '29-1',
        label: 'Igyekszem nem megsérteni a másik érzéseit.',
        result: 'problemSolver',
      },
      {
        id: '29-2',
        label: 'Mindig megosztom a problémát a másikkal, a megoldás érdekében.',
        result: 'adaptable',
      },
    ],
  },
];

const getResult = (answers) => {
  const result = {
    dominant: 0,
    problemSolver: 0,
    comporomise: 0,
    bypass: 0,
    adaptable: 0,
  };

  for (const answer of answers) {
    result[answer.result]++;
  }

  return result;
};

const maxResult = 12;

const rowLabels = ['Magas', 'Közepes', 'Alacsony'];

const questionsData = {
  questionsTitle,
  questionsDescription,
  questions,
  getResult,
  resultColumns,
  maxResult,
  rowLabels,
};

export default questionsData;
